var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import dayjs from 'dayjs';
import { Vue } from 'vue-property-decorator';
import { AiReportEditMutationTypes } from '@/types/ai-report-edit';
import reportApiClient from '@/plugins/apis/report-api-client';
import contentApiClient from '@/plugins/apis/content-api-client';
import checkFirebaseAuthAndDoAction from '@/plugins/check-firebase-auth-and-do-action';
export var state = function () { return ({
    project_title: '',
    address: '',
    construction_start_date: null,
    construction_end_date: null,
    cost: null,
    description: '',
    report_fields: [],
    content_id: ''
}); };
export var getters = {
    projectTitle: function (state) {
        return state.project_title;
    },
    address: function (state) {
        return state.address;
    },
    constructionStartDate: function (state) {
        return state.construction_start_date;
    },
    constructionEndDate: function (state) {
        return state.construction_end_date;
    },
    cost: function (state) {
        return state.cost;
    },
    description: function (state) {
        return state.description;
    },
    reportFields: function (state) {
        return state.report_fields;
    },
    contentId: function (state) {
        return state.content_id;
    }
};
export var mutations = (_a = {},
    _a[AiReportEditMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[AiReportEditMutationTypes.FETCH_REPORT] = function (state, payload) {
        if (payload.report_information) {
            state.project_title = payload.report_information.project_title;
            state.address = payload.report_information.address;
            var cost = Number.parseInt(payload.report_information.cost);
            if (Number.isInteger(cost)) {
                state.cost = cost;
            }
            state.description = payload.report_information.description;
            state.construction_start_date = dayjs(payload.report_information.start_date).toDate();
            state.construction_end_date = dayjs(payload.report_information.end_date).toDate();
            state.report_fields = payload.report_fields || [];
            state.content_id = payload.content_id;
        }
    },
    _a[AiReportEditMutationTypes.SET_PROJECT_TITLE] = function (state, payload) {
        state.project_title = payload;
    },
    _a[AiReportEditMutationTypes.SET_ADDRESS] = function (state, payload) {
        state.address = payload;
    },
    _a[AiReportEditMutationTypes.SET_CONSTRUCTION_START_DATE] = function (state, payload) {
        state.construction_start_date = payload;
    },
    _a[AiReportEditMutationTypes.SET_CONSTRUCTION_END_DATE] = function (state, payload) {
        state.construction_end_date = payload;
    },
    _a[AiReportEditMutationTypes.SET_COST] = function (state, payload) {
        state.cost = payload;
    },
    _a[AiReportEditMutationTypes.SET_DESCRIPTION] = function (state, payload) {
        state.description = payload;
    },
    _a[AiReportEditMutationTypes.UPDATE_FIELD] = function (state, payload) {
        var index = state.report_fields.findIndex(function (field) { return field.id === payload.id; });
        if (index >= 0) {
            Vue.set(state.report_fields, index, payload);
        }
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.INIT_STATE, state());
    },
    fetchReport: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, reportApiClient.fetchReport(payload, 'ai')];
                    case 1:
                        response = _b.sent();
                        commit(AiReportEditMutationTypes.FETCH_REPORT, response.data.report);
                        return [2 /*return*/];
                }
            });
        });
    },
    setProjectTitle: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_PROJECT_TITLE, payload);
    },
    setAddress: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_ADDRESS, payload);
    },
    setConstructionStartDate: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_CONSTRUCTION_START_DATE, payload);
    },
    setConstructionEndDate: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_CONSTRUCTION_END_DATE, payload);
    },
    setCost: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_COST, payload);
    },
    setDescription: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.SET_DESCRIPTION, payload);
    },
    updateField: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportEditMutationTypes.UPDATE_FIELD, payload);
    },
    updateAiReport: function (_a, payload) {
        var _b, _c;
        var getters = _a.getters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var upload, _i, _d, field, _loop_1, _e, _f, fieldContent, informationParams, fieldsParmas;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        upload = function (url, name) { return __awaiter(_this, void 0, Promise, function () {
                            var response, blob, file;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetch(url)];
                                    case 1:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.blob()];
                                    case 2:
                                        blob = _a.sent();
                                        file = new File([blob], name, {
                                            type: blob.type,
                                            lastModified: Date.now()
                                        });
                                        return [2 /*return*/, dispatch('uploadContent', file)];
                                }
                            });
                        }); };
                        _i = 0, _d = getters.reportFields;
                        _g.label = 1;
                    case 1:
                        if (!(_i < _d.length)) return [3 /*break*/, 6];
                        field = _d[_i];
                        _loop_1 = function (fieldContent) {
                            var dupFieldContent, content, content;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        dupFieldContent = __assign({}, fieldContent);
                                        if (!((_b = fieldContent.before_content_url) === null || _b === void 0 ? void 0 : _b.startsWith('blob'))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, upload(fieldContent.before_content_url, fieldContent.process_name + ".jpg")];
                                    case 1:
                                        content = _a.sent();
                                        if (content) {
                                            dupFieldContent.before_content_id = content.id;
                                            dupFieldContent.before_content_url = content.thumb_url;
                                        }
                                        _a.label = 2;
                                    case 2:
                                        if (!((_c = fieldContent.after_content_url) === null || _c === void 0 ? void 0 : _c.startsWith('blob'))) return [3 /*break*/, 4];
                                        return [4 /*yield*/, upload(fieldContent.after_content_url, fieldContent.process_name + ".jpg")];
                                    case 3:
                                        content = _a.sent();
                                        if (content) {
                                            dupFieldContent.after_content_id = content.id;
                                            dupFieldContent.after_content_url = content.thumb_url;
                                        }
                                        _a.label = 4;
                                    case 4:
                                        commit(AiReportEditMutationTypes.UPDATE_FIELD, __assign(__assign({}, field), { report_fields_contents: field.report_fields_contents.map(function (fc) {
                                                return fc.id === fieldContent.id ? dupFieldContent : fc;
                                            }) }));
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _e = 0, _f = field.report_fields_contents;
                        _g.label = 2;
                    case 2:
                        if (!(_e < _f.length)) return [3 /*break*/, 5];
                        fieldContent = _f[_e];
                        return [5 /*yield**/, _loop_1(fieldContent)];
                    case 3:
                        _g.sent();
                        _g.label = 4;
                    case 4:
                        _e++;
                        return [3 /*break*/, 2];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        informationParams = {
                            project_title: getters.projectTitle,
                            address: getters.address,
                            cost: (getters.cost || '').toString(),
                            description: getters.description,
                            start_date: (getters.constructionStartDate || '').toString(),
                            end_date: (getters.constructionEndDate || '').toString()
                        };
                        fieldsParmas = getters.reportFields;
                        return [4 /*yield*/, reportApiClient.updateAiReport(payload, {
                                informationParams: informationParams,
                                fieldsParmas: fieldsParmas
                            })];
                    case 7:
                        _g.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    uploadContent: function (_a, payload) {
        var getters = _a.getters, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var res_1, content_1, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, contentApiClient.uploadContent(getters.contentId, payload, {})];
                    case 1:
                        res_1 = _b.sent();
                        if (res_1.status === 200) {
                            content_1 = res_1.data.content;
                            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                var company;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, contentApiClient.uploadFileS3Request(res_1.data.meta, payload)];
                                        case 1:
                                            _a.sent();
                                            company = rootGetters['initial-setting/company'];
                                            checkFirebaseAuthAndDoAction(function () {
                                                contentApiClient.uploadFileFirebaseRequest(content_1);
                                            }, company.id);
                                            this.app.$gtag('event', Vue.prototype.$gaEvent.actionFileUpload);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 200);
                            return [2 /*return*/, content_1];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};
